module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phase-explorer",
    class: {
      collapsed: _vm.collapsed,
      peeking: _vm.collapsed && _vm.peeking
    },
    style: ((!_vm.collapsed || _vm.peeking) ? {
      width: _vm.width + 'px'
    } : null),
    on: {
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "click": _vm.onPanelClick
    }
  }, [(!_vm.collapsed) ? _c('div', {
    staticClass: "pe-resize",
    attrs: {
      "title": "Drag to resize"
    },
    on: {
      "mousedown": _vm.startResize
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pe-head"
  }, [(!_vm.collapsed || _vm.peeking) ? _c('span', {
    staticClass: "pe-title"
  }, [_vm._v(_vm._s(_vm.selectedPhase ? 'Phase Details' : 'Client View'))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pe-toggle",
    attrs: {
      "title": _vm.collapsed ? 'Expand' : 'Collapse'
    },
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "9 18 15 12 9 6"
    }
  })])])]), _vm._v(" "), (!_vm.collapsed || _vm.peeking) ? _c('div', {
    staticClass: "pe-body"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "pe-loading"
  }, [_vm._v("Generating client presentation…")]) : (_vm.presentation) ? [(_vm.selectedPhase) ? _c('div', [_c('button', {
    staticClass: "pe-back",
    on: {
      "click": function($event) {
        return _vm.$emit('deselect')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "15 18 9 12 15 6"
    }
  })]), _vm._v("\n          Back to phases\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "pe-badge",
    style: (_vm.chipStyle(_vm.selectedPhase.color))
  }, [_vm._v(_vm._s(_vm.typeLabel(_vm.selectedPhase.type)))]), _vm._v(" "), _c('div', {
    staticClass: "pe-detail-name"
  }, [_vm._v(_vm._s(_vm.selectedPhase.label))]), _vm._v(" "), _c('div', {
    staticClass: "pe-detail-desc"
  }, [_vm._v(_vm._s(_vm.selectedPhase.description))]), _vm._v(" "), _c('div', {
    staticClass: "pe-detail-section"
  }, [_c('div', {
    staticClass: "pe-detail-h"
  }, [_vm._v("Stages (" + _vm._s(_vm.selectedPhase.stages.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "pe-stage-chips"
  }, _vm._l((_vm.selectedPhase.stages), function(s) {
    return _c('span', {
      key: s,
      staticClass: "pe-stage-chip"
    }, [_vm._v(_vm._s(s))])
  }), 0)]), _vm._v(" "), (_vm.selectedPhase.key_questions && _vm.selectedPhase.key_questions.length) ? _c('div', {
    staticClass: "pe-detail-section"
  }, [_c('div', {
    staticClass: "pe-detail-h"
  }, [_vm._v("Key Questions")]), _vm._v(" "), _vm._l((_vm.selectedPhase.key_questions), function(q, qi) {
    return _c('div', {
      key: qi,
      staticClass: "pe-q-card"
    }, [_c('div', {
      staticClass: "pe-q-stage"
    }, [_vm._v(_vm._s(q.stage))]), _vm._v(" "), _c('div', {
      staticClass: "pe-q-text"
    }, [_vm._v(_vm._s(q.question_summary))]), _vm._v(" "), _c('div', {
      staticClass: "pe-q-opts"
    }, _vm._l((q.options_summary), function(o, oi) {
      return _c('div', {
        key: oi,
        staticClass: "pe-q-opt"
      }, [_vm._v(_vm._s(o))])
    }), 0)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.selectedPhase.branches_to && _vm.selectedPhase.branches_to.length) ? _c('div', {
    staticClass: "pe-detail-section"
  }, [_c('div', {
    staticClass: "pe-detail-h"
  }, [_vm._v("Branches To")]), _vm._v(" "), _vm._l((_vm.selectedPhase.branches_to), function(b, bi) {
    return _c('div', {
      key: bi,
      staticClass: "pe-branch-item",
      on: {
        "click": function($event) {
          return _vm.$emit('select-phase', b.target_phase)
        }
      }
    }, [_c('span', {
      staticClass: "pe-phase-chip",
      style: (_vm.chipStyleByPhaseId(b.target_phase))
    }, [_vm._v(_vm._s(_vm.phaseLabel(b.target_phase)))]), _vm._v(" "), _c('span', {
      staticClass: "pe-branch-cond"
    }, [_vm._v(_vm._s(b.condition))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.selectedPhase.exit_points && _vm.selectedPhase.exit_points.length) ? _c('div', {
    staticClass: "pe-detail-section"
  }, [_c('div', {
    staticClass: "pe-detail-h"
  }, [_vm._v("Exit Points")]), _vm._v(" "), _vm._l((_vm.selectedPhase.exit_points), function(ep, ei) {
    return _c('div', {
      key: ei,
      staticClass: "pe-exit-item"
    }, [_c('span', {
      staticClass: "pe-mono"
    }, [_vm._v(_vm._s(ep.stage))]), _vm._v(" — " + _vm._s(ep.reason) + "\n          ")])
  })], 2) : _vm._e()]) : _c('div', [(_vm.presentation.summary) ? _c('div', {
    staticClass: "pe-summary"
  }, [_vm._v(_vm._s(_vm.presentation.summary))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pe-stages-head"
  }, [_vm._v("Phases · " + _vm._s(_vm.phases.length))]), _vm._v(" "), _c('div', {
    staticClass: "pe-list"
  }, _vm._l((_vm.phases), function(p) {
    return _c('div', {
      key: p.id,
      staticClass: "pe-card",
      on: {
        "click": function($event) {
          return _vm.$emit('select-phase', p.id)
        }
      }
    }, [_c('div', {
      staticClass: "pe-name"
    }, [_vm._v(_vm._s(p.label))]), _vm._v(" "), _c('div', {
      staticClass: "pe-meta"
    }, [_c('span', {
      staticClass: "pe-badge",
      style: (_vm.chipStyle(p.color))
    }, [_vm._v(_vm._s(_vm.typeLabel(p.type)))]), _vm._v(" "), _c('span', {
      staticClass: "pe-desc"
    }, [_vm._v(_vm._s(p.stages.length) + " stage" + _vm._s(p.stages.length === 1 ? '' : 's'))])])])
  }), 0), _vm._v(" "), (_vm.presentation.loops && _vm.presentation.loops.length) ? _c('div', {
    staticClass: "pe-detail-section"
  }, [_c('div', {
    staticClass: "pe-detail-h"
  }, [_vm._v("Loops")]), _vm._v(" "), _vm._l((_vm.presentation.loops), function(loop, li) {
    return _c('div', {
      key: li,
      staticClass: "pe-loop-item"
    }, [_c('span', {
      staticClass: "pe-phase-chip",
      style: (_vm.chipStyleByPhaseId(loop.from_phase))
    }, [_vm._v(_vm._s(_vm.phaseLabel(loop.from_phase)))]), _vm._v(" "), _c('span', {
      staticClass: "pe-loop-arrow"
    }, [_vm._v("↻")]), _vm._v(" "), _c('span', {
      staticClass: "pe-phase-chip",
      style: (_vm.chipStyleByPhaseId(loop.to_phase))
    }, [_vm._v(_vm._s(_vm.phaseLabel(loop.to_phase)))]), _vm._v(" "), _c('div', {
      staticClass: "pe-loop-trigger"
    }, [_vm._v(_vm._s(loop.trigger))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.presentation.exit_points_summary && _vm.presentation.exit_points_summary.length) ? _c('div', {
    staticClass: "pe-detail-section"
  }, [_c('div', {
    staticClass: "pe-detail-h"
  }, [_vm._v("Exit Points")]), _vm._v(" "), _vm._l((_vm.presentation.exit_points_summary), function(ep, ei) {
    return _c('div', {
      key: ei,
      staticClass: "pe-exit-item"
    }, [_c('span', {
      staticClass: "pe-mono"
    }, [_vm._v(_vm._s(ep.stage))]), _vm._v(" — " + _vm._s(ep.reason) + "\n          ")])
  })], 2) : _vm._e()])] : _c('div', {
    staticClass: "pe-empty"
  }, [_vm._v("No presentation generated yet.")])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-be1ce522","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/PhaseExplorer.vue
// module id = rr7S
// module chunks = 1